import { getStack } from '@/lib/contentstack/stack';
const locale = process.env.NEXT_PUBLIC_APP_LOCALE;

export async function categoryArticlesClient(categoryTitle, skip, limit = 279) {
  try {
    const response = await fetchArticlesInCategory(limit, skip, categoryTitle);
    const [filteredArticles, count] = response;

    return {
      articles: formatArticles(filteredArticles),
      totalCount: count
    };
  } catch (error) {
    console.error('Error fetching category articles:', error);
    throw error;
  }
}

// Fetches articles, filtering by category and excluding "priority" tag
export async function fetchArticlesInCategory(limit, skipNum, categoryTitle) {
  const Stack = getStack();
  const query = Stack.ContentType('article')
    .Query()
    .where('locale', locale)
    .skip(skipNum)
    .limit(limit)
    .includeReference('category', 'feature_image')
    .referenceIn('category', { title: categoryTitle }) // Filter by category
    .only([
      'uid',
      'title',
      'url',
      'date',
      'category.uid', // So the cached server-side twin can tag the category
      'category.title',
      'category.url',
      'rich_text_editor',
      'feature_image.dimension',
      'feature_image.title',
      'feature_image.url'
    ])
    .query({
      tags: { $nin: ['priority'] } // Exclude articles with "priority" tag
    })
    .addParam('include_dimension', 'true')
    .includeCount()
    .descending('created_at')
    .toJSON();
  return await query.find();
}

// Helper to format articles with specified fields and pagination
export function formatArticles(articles) {
  return articles.map((article) => ({
    title: article.title,
    url: article.url,
    date: article.date,
    categoryConnection: {
      title: article.category[0]?.title,
      url: article.category[0]?.url
    },
    rich_text_editor: article.rich_text_editor,
    feature_image: {
      dimension: article.feature_image?.dimension,
      title: article.feature_image?.title,
      url: article.feature_image?.url
    }
  }));
}
